module.exports = __webpack_public_path__ + "res/michine_online_icon.png";